import { isDate } from 'date-fns';
import { combineLatest, Observable, of } from 'rxjs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeEmpty: any = (obj: any = {}) =>
  Object.keys(obj)
    .filter(
      (k) =>
        (obj[k] !== null && obj[k] !== undefined) ||
        (Array.isArray(obj[k]) && Array.from(obj[k]).length !== 0),
    )
    .reduce(
      (newObj, k) =>
        typeof obj[k] === 'object' && !isDate(obj[k]) && !Array.isArray(obj[k])
          ? Object.assign(newObj, { [k]: removeEmpty(obj[k]) })
          : Object.assign(newObj, { [k]: obj[k] }),
      {},
    );
/* eslint-disable @typescript-eslint/no-explicit-any */
export function attachmentsToBase64(files: any[]) {
  return files.length > 0 ? combineLatest(files.map((file) => toBase64(file))) : of([]);
}
/* eslint-disable @typescript-eslint/no-explicit-any */
export function toBase64(
  file: any,
): Observable<{ name: string; base64: any; contentType: string }> {
  return new Observable((subscriber) => {
    const reader = new FileReader();

    reader.onload = () => {
      const result = ensureString(reader.result);
      subscriber.next({ name: file.name, base64: result.split(',')[1], contentType: file.type });
      subscriber.complete();
    };

    reader.onerror = (error) => {
      subscriber.error(error);
    };

    reader.readAsDataURL(file);
  });
}

export function ensureString(input: string | ArrayBuffer | null): string {
  if (typeof input === 'string') {
    return input;
  } else {
    return arrayBufferToString(input as ArrayBuffer);
  }
}

export function arrayBufferToString(buffer: ArrayBuffer): string {
  const decoder = new TextDecoder('utf-8');
  return decoder.decode(buffer);
}

export async function getCodes() {
  const inputBytes = getRandomBytes();
  const verifier = buf2Base64(inputBytes);

  const shaHash = await windowSha256(verifier);
  const codeChallenge = buf2Base64(shaHash);

  return { verifier, codeChallenge };
}

export function getParameterByName(name: string, url = window.location.href) {
  /* eslint-disable no-useless-escape */
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export async function windowSha256(buffer: string | undefined) {
  const bytes = new TextEncoder().encode(buffer);
  return await crypto.subtle.digest('SHA-256', bytes);
}

export function getRandomBytes() {
  const rndArray = new Uint8Array(44);
  crypto.getRandomValues(rndArray);
  return rndArray;
}

export function buf2Base64(buffer: ArrayBuffer) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  return btoa(String.fromCharCode.apply(null, new Uint8Array(buffer) as any))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}

export function buildJdOpener(jd: string): string {
  const prefix = 'Uploaded a job description for: ';
  const firstNonEmptyLine = jd.split('\n').find((line) => line.trim().length > 0) ?? '';
  return prefix + firstNonEmptyLine.trim().slice(0, 80);
}

export function dateRangeParams(from?: string, to?: string): Record<string, string> {
  const params: Record<string, string> = {};
  if (from) params['from'] = from;
  if (to) params['to'] = to;
  return params;
}
